<template>
  <div>
    <span
      v-if="error"
      class="text-red-500 font-bold">
      {{error}}
    </span>
  </div>
</template>

<script>
export default {
  name: 'Error',
  props: {
    error: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/others/utils/error.vue